import ApiPermisos from '../../services/apiPermisos'

export default {
  namespaced: true,
  state: {
    errorMsj: '',
    loadingNovelties: false,
    loadingNoveltiesDetail: false,
    loadingNoveltiesDetailModal: false,
    novelties:{
      data: {}
    },
    detailnovelties:{
      data: {}
    },
    detailnoveltiesDatatable:[]
  },
  getters: {
    getAllNovelties: (state) =>{
      return state.novelties;
    },

    getAllDetailNovelties: (state) =>{
      return state.detailnovelties;
    },

    getAllDetailNoveltiesDatatable: (state) =>{
      return state.detailnoveltiesDatatable;
    
    },
    
  },
  mutations: {

    setLoading:(state, loading) => {
      state.loadingNovelties = [];
      state.loadingNovelties = loading;
    },
    setLoadingDetail:(state, loading) => {
      state.loadingNoveltiesDetail = [];
      state.loadingNoveltiesDetail = loading;
    },

    setLoadingDetailModal:(state, loading) => {
      state.loadingNoveltiesDetailModal = [];
      state.loadingNoveltiesDetailModal = loading;
    },

    
    setNovelties: (state, novelties) => {
      state.novelties = [];
      state.novelties = novelties;
    },

    setDetailNovelties: (state, detailnovelties) => {
      state.detailnovelties = [];
      state.detailnovelties = detailnovelties;
    },   

    setDetailnoveltiesDatatable: (state, detailnoveltiesDatatable) => {
      state.detailnoveltiesDatatable = [];
      state.detailnoveltiesDatatable = detailnoveltiesDatatable;
    },   

    
    
    setToggleDetail: (state, detailnoveltiesDatatable) => {
      // Seleccionar el detalle.
      let detailnoveltiesDatatable_ = state.detailnoveltiesDatatable;
      for(var i = 0;  i < detailnoveltiesDatatable_.length; i++){
        if(detailnoveltiesDatatable_[i].id == detailnoveltiesDatatable.id){
          //console.log('antes',detailnoveltiesDatatable_[i].selected);
          detailnoveltiesDatatable_[i].selected = 
            (detailnoveltiesDatatable_[i].selected == undefined)?true:
            !detailnoveltiesDatatable_[i].selected;
          //console.log('despues',detailnoveltiesDatatable_[i].selected);
        }
      }
    
    },
    
  },
  actions: { 

     // Listar datatable de las novedades
     actGetNovelties: async ({
      commit
    },data) => {
        commit('setLoading', true);
        let response = {};
        response = await ApiPermisos.getlistNovelties(data);        
        if (response.error) {
            return response.error;
        }else{
          commit('setLoading', false);
          commit('setNovelties', response);
        }
        return response;
    },


    // Obtener el detallado de las novedades
    actGetDetailNovelties: async ({
      commit
    },data) => {
        commit('setLoadingDetail', true);
        let response = {};
        response = await ApiPermisos.getlistDetailNovelties(data);   
        if (response.error) {
            return response.error;
        }else{
          commit('setLoadingDetail', false);
          commit('setDetailNovelties', response);
          commit('setDetailnoveltiesDatatable', [response.data]);
        }
        return response;
    },


    // Toggle detallle
    toggleDetail: async ({
      commit
    },data) => {
        commit('setLoadingDetail', true);
        commit('setToggleDetail', data);
        commit('setLoadingDetail', false);
        return data;
    },

    // Confirmar detalle de la novedad
    confirmNoveltie: async ({
      commit
    },data) => {
      commit('setLoadingDetailModal', true);
      let response = {};
      response = await ApiPermisos.confirmNoveltie(data);   
      if (response.error) {
          return response.error;
      }else{
        commit('setLoadingDetailModal', false);
      }
      return response;
    },


    
    
  },
}